<template>
<div class="main-body">
  <b-alert
    dismissible
    :show="showDismissibleAlert"
    :variant="alertVariant"
    @dismissed="showDismissibleAlert=false">{{ alertMessage }}</b-alert>
    <form>
      <div class="card">
          <div class="card-body">
              <div class="row">
                  <div class="col-sm-5">
                      <h4 class="card-title mb-0">
                        Supplier Management <small class="text-muted">suppliers</small>
                      </h4>
                  </div><!--col-->
              </div><!--row-->
              <div class="row mt-4">
                  <div class="col">
                    <div class="form-group row">
                      <label for="primary_name" class="col-sm-2 col-form-label form__label">{{ $t('supplier.primary_name') }}</label>
                      <div class="col-sm-6" v-bind:class="{'form-group--error': $v.supplier.primary_name.$error }">
                        <input v-model.trim="supplier.primary_name" @input="$v.supplier.primary_name.$touch()" type="text" name="primary_name" class="form-control form__label">
                      </div>
                    </div>
                    <div class="form-group row">
                      <label for="secondary_name" class="col-sm-2 col-form-label">{{ $t('supplier.secondary_name') }}</label>
                      <div class="col-sm-6">
                        <input v-model.trim="supplier.secondary_name" type="text" name="secondary_name" class="form-control" />
                      </div>
                    </div>
                    <div class="form-group row">
                      <label for="address" class="col-sm-2 col-form-label">{{ $t('supplier.address') }}</label>
                      <div class="col-sm-6">
                        <input v-model.trim="supplier.address" type="text" name="address" class="form-control" />
                      </div>
                    </div>
                    <div class="form-group row">
                      <label for="postal_address" class="col-sm-2 col-form-label">{{ $t('supplier.postal_address') }}</label>
                      <div class="col-sm-6">
                        <input v-model.trim="supplier.postal_address" type="text" name="postal_address" class="form-control" />
                      </div>
                    </div>
                    <div class="form-group row">
                      <label for="payee_bank_name" class="col-sm-2 col-form-label">{{ $t('supplier.payee_bank_name') }}</label>
                      <div class="col-sm-6">
                        <input v-model.trim="supplier.payee_bank_name" type="text" name="payee_bank_name" class="form-control" />
                      </div>
                    </div>
                    <div class="form-group row">
                      <label for="payee_bank_swiftbic" class="col-sm-2 col-form-label">{{ $t('supplier.payee_bank_swiftbic') }}</label>
                      <div class="col-sm-6">
                        <input v-model.trim="supplier.payee_bank_swiftbic" type="text" name="payee_bank_swiftbic" class="form-control" />
                      </div>
                    </div>
                    <div class="form-group row">
                      <label for="payee_bank_account_name" class="col-sm-2 col-form-label">{{ $t('supplier.payee_bank_account_name') }}</label>
                      <div class="col-sm-6">
                        <input v-model.trim="supplier.payee_bank_account_name" type="text" name="payee_bank_account_name" class="form-control" />
                      </div>
                    </div>
                    <div class="form-group row">
                      <label for="email" class="col-sm-2 col-form-label">{{ $t('supplier.email') }}</label>
                      <div class="col-sm-6">
                        <input v-model.trim="supplier.email" type="text" name="email" class="form-control" />
                      </div>
                    </div>
                    <div class="form-group row">
                      <label for="tel" class="col-sm-2 col-form-label">{{ $t('supplier.tel') }}</label>
                      <div class="col-sm-3">
                        <input v-model.trim="supplier.tel" type="text" name="tel" class="form-control" />
                      </div>
                      <label for="fax" class="col-sm-2 col-form-label">{{ $t('supplier.fax') }}</label>
                      <div class="col-sm-3">
                        <input v-model.trim="supplier.fax" type="text" name="fax" class="form-control" />
                      </div>
                    </div>
                    <div class="form-group row">
                      <label for="mobile" class="col-sm-2 col-form-label">{{ $t('supplier.mobile') }}</label>
                      <div class="col-sm-3">
                        <input v-model.trim="supplier.mobile" type="text" name="mobile" class="form-control" />
                      </div>
                      <label for="contact_person" class="col-sm-2 col-form-label">{{ $t('supplier.contact_person') }}</label>
                      <div class="col-sm-3">
                        <input v-model.trim="supplier.contact_person" type="text" name="contact_person" class="form-control" />
                      </div>
                    </div>
                    <!-- <div class="form-group row">
                      <label for="br" class="col-sm-2 col-form-label">{{ $t('supplier.br') }}</label>
                      <div class="col-sm-6">
                        <input v-model.trim="supplier.br" type="text" name="br" class="form-control" />
                      </div>
                    </div> -->
                  </div><!--col-->
              </div><!--row-->
              <div slot="footer">
                <div class="row">
                    <div class="col-7">
                        <div class="float-left"></div>
                    </div><!--col-->
                    <div class="col-5">
                        <div class="float-right">
                            <b-button type="submit" size="sm" variant="primary" @click.stop.prevent="handleSubmit"><i class="fa fa-dot-circle-o"></i> Submit</b-button>
                        </div>
                    </div><!--col-->
                </div><!--row-->
              </div>
          </div><!--card-body-->
      </div><!--card-->
    </form>
   <loading-panel v-if="showLoadingPanel"></loading-panel>
  </div>
</template>
<script>
import { required } from 'vuelidate/lib/validators'
import loadingPanel from '@/components/LoadingPanel'

export default {
  name: 'SupplierCreate',
  components: {
    loadingPanel
  },
  mounted () {
  },
  data () {
    return {
      supplier: {
        primary_name: '',
        secondary_name: '',
        address: '',
        postal_address: '',
        payee_bank_name: '',
        payee_bank_swiftbic: '',
        payee_bank_account_name: '',
        email:'',
        tel: '',
        fax: '',
        mobile: '',
        contact_person: '',
        br: '',
        status: true
      },
      showLoadingPanel: false,
      showDismissibleAlert: false,
      alertVariant: '',
      alertMessage: '',
      message: ''
    }
  },
  methods: {
    handleSubmit () {
      this.$v.supplier.$touch()
      if (this.$v.supplier.$error) {
        this.$swal({
          title: 'You have not set your supplier primary name',
          icon: 'warning',
          animation: false,
          customClass: 'animated tada'
        })
        return
      }
      // create supplier
      this.showLoadingPanel = true
      this.axios.post('/supplier', this.supplier).then(() => {
        this.showLoadingPanel = false
        this.$router.push('/supplier')
      }).catch(error => {
        this.showLoadingPanel = false
        this.showAlert('danger', error.data.message)
      })
    },
    showAlert (alertVariant, message) {
      this.showDismissibleAlert = true
      this.alertVariant = alertVariant
      this.alertMessage = message
    }
  },
  validations: {
    supplier: {
      primary_name: {
        required
      },
    }
  }
}
</script>
